<template>
	<div class="filter-box">
		<div class="filter-content">
			<settingRow
				v-for="(filter, index) in filterList"
				:key="`filter-${index}`"
				:id="filter.id"
				:title="filter.title"
				:color="filter.color"
				@colorChange="handleColorChange"
			/>
		</div>
	</div>
</template>

<script>
import { filters } from '../api.js';
import settingRow from './settingRow';
export default {
	name: 'settings',
	components: { settingRow },
	data() {
		return {
			filterList: [...filters],
		};
	},
	mounted() {
		const settings = JSON.parse(this.localStorageLoad());
		this.filterList = this.filterList.map(filter => {
			return {
				...filter,
				color: settings[filter.id],
			};
		});
	},
	methods: {
		handleColorChange({ id, colorValue }) {
			const currentStorageSettings = JSON.parse(this.localStorageLoad());
			currentStorageSettings[id] = colorValue;
			this.localStorageUpdate(currentStorageSettings);
			// set new color to filterList
			const currentFilter = this.filterList.find(filter => filter.id === id);
			currentFilter.color = colorValue;
			this.$emit('shiftColorsChange', currentStorageSettings);
		},
		localStorageLoad() {
			return localStorage.getItem('scheduling');
		},
		localStorageUpdate(itemsObject) {
			localStorage.setItem('scheduling', JSON.stringify(itemsObject));
		},
	},
};
</script>

<style lang="scss" scoped>
.filter-content {
	padding: 20px;
	margin-top: 50px;
}
</style>
